module.exports = __webpack_public_path__ + "img/cat-gliets.adebc91f.png";